import * as Sentry from '@sentry/react'
import { ReactElement, useEffect } from 'react'

const AppContext = {
  SSF: 'ssf',
}

interface Props {
  element: React.ReactNode
  tags: {
    [key: string]: string | number | boolean
  }
}

/**
 * Use if you want to wrap a component (including Route) and add Sentry tags
 */
const WithSentryTags = ({ element, tags }: Props) => {
  useEffect(() => {
    Sentry.setTags(tags)
  })

  return element
}

export const WithSSFSentryTags = (element: ReactElement) => (
  <WithSentryTags
    element={element}
    tags={{
      appContext: AppContext.SSF,
    }}
  />
)
